import { render, staticRenderFns } from "./ImageDefaultLayout.vue?vue&type=template&id=5372df8a&scoped=true&"
import script from "./ImageDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./ImageDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372df8a",
  null
  
)

export default component.exports